import React, {useEffect, useRef, useState} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'

import {TableTemplateCSS} from '../../components/Table/TableCSS'
import TableTemplate from '../../components/Table/TableTemplate'
import {ColumnDef, ColumnPinningState} from '@tanstack/react-table'
import IndeterminateCheckbox from '../../components/Table/IndeterminateCheckbox'
import FormatDate from '../../components/FormatDate'
import {OverlayTrigger} from 'react-bootstrap'
import popover from '../../components/Popover'
import FormatNumber from '../../components/FormatNumber'
import {useUSSDTransStore} from './USSD-Trans-Store'
import {USSD_Trans_Filter} from './USSD-Trans-Filter'

const USSD_Trans_List: React.FC = () => {
  //Table Related
  const [rowSelection, setRowSelection] = React.useState({})
  const [totalCount, setTotalCount] = useState(0)
  const [columnVisibility, setColumnVisibility] = React.useState({})
  const [columnPinning, setColumnPinning] = useState<ColumnPinningState>({
    left: ['select'],
    right: ['action'],
  })
  const [pagination, setPagination] = useState({
    pageIndex: 0, //initial page index
    pageSize: 200, //default page size
  })
  useEffect(() => {
    const selectedIndices = Object.keys(rowSelection).map((key) => parseInt(key, 10))
    const filteredSelectedRowData: any = formData
      .filter((_: any, index: number) => selectedIndices.includes(index))
      .map((row: any) => row)

    setSelectedArray(filteredSelectedRowData)
  }, [rowSelection])
  //Table Related

  //States
  const [formData, setFormData] = useState([])
  const [depositData, setDepositData] = useState(Object)
  const [showMetrics, setShowMetrics] = useState(false)
  const [selectedArray, setSelectedArray] = useState([])
  const [isAction, setIsAction] = useState(false)
  const [metrics, setMatrics] = useState<any>(undefined)
  const [filterValues, setFilterValues] = useState<any>([])
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [currentRejectDeposit, setCurrentRejectDeposit] = useState('')
  const [firstLoad, setFirstLoad] = useState(true)

  //Refs
  const ussdTransFilterBtn = useRef<any>()

  //Zustand Store
  const setGetData = useUSSDTransStore((state: any) => state.setGetData)

  //Table::START

  useEffect(() => {
    let metrics = localStorage.getItem('depositMetrics')
    if (metrics) {
      setMatrics(JSON.parse(metrics))
    } else {
      setMatrics([])
    }
  }, [formData, showMetrics])

  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      {
        id: 'select',
        accessorKey: 'select',
        enableColumnFilter: false,
        size: 50,
        header: ({table}) => (
          <div
            className='px-1'
            style={{
              backgroundColor: 'transparent',
            }}
          >
            <IndeterminateCheckbox
              {...{
                checked: table.getIsAllRowsSelected(),
                indeterminate: table.getIsSomeRowsSelected(),
                onChange: table.getToggleAllRowsSelectedHandler(),
              }}
            />
          </div>
        ),
        cell: ({row}) => (
          <div
            className='px-1'
            style={{
              backgroundColor: 'transparent',
            }}
          >
            <IndeterminateCheckbox
              {...{
                checked: row.getIsSelected(),
                disabled: !row.getCanSelect(),
                indeterminate: row.getIsSomeSelected(),
                onChange: row.getToggleSelectedHandler(),
              }}
            />
          </div>
        ),
      },
      {
        id: 'withdrawalDT',
        header: 'Withdrawal DateTime',
        accessorKey: 'withdrawalDT',
        cell: (info) => FormatDate(info.getValue()),
        enableColumnFilter: false,
        size: 250,
      },
      {
        header: 'TxnID',
        accessorKey: 'txnId',
        cell: (info) => info.getValue(),
        enableColumnFilter: false,
      },
      {
        header: 'Channel',
        accessorKey: 'channel',
        cell: (info) => info.getValue(),
        enableColumnFilter: false,
      },
      {
        header: 'Agent Name',
        accessorKey: 'agentName',
        cell: (info) => info.getValue(),
        enableColumnFilter: false,
      },
      {
        id: 'walletAccNo',
        header: 'Wallet Account No',
        accessorKey: 'walletAccNo',
        cell: (info: any) => info.getValue(),
        enableColumnFilter: false,
        size: 250,
      },
      {
        id: 'amount',
        header: 'Amount',
        accessorKey: 'amount',
        cell: (info: any) => FormatNumber(info.getValue()),
        enableColumnFilter: false,
        size: 250,
      },
    ],
    []
  )

  return (
    <div>
      <div className='d-flex justify-content-between mb-5'>
        <div className='d-flex'>
          <div className='fv-row  me-5'>
            <button
              className='btn btn-info btn-sm fw-bold btn-color-white-700 w-100'
              disabled={formData.length > 0 && !downloadLoading ? false : true}
              onClick={() => {
                // Deposit_Export_CSV(filterValues, setDownloadLoading)
              }}
            >
              {!downloadLoading ? 'Download Content as CSV' : 'Downloading...Please Wait!'}
            </button>
          </div>
        </div>
        <button
          type='button'
          className='btn btn-sm btn-flex fw-bold rotate'
          onClick={(e) => {
            setShowMetrics(!showMetrics)
            e.currentTarget.classList.toggle('active')
          }}
        >
          <KTSVG
            path='/media/icons/duotune/arrows/arr004.svg'
            className='svg-icon-6 svg-icon-muted me-1 rotate-180'
          />{' '}
          Select Metrics
        </button>
      </div>

      <USSD_Trans_Filter
        setTotalCount={setTotalCount}
        setFormData={setFormData}
        formData={formData}
        setSelectedArray={setSelectedArray}
        ussdTransFilterBtn={ussdTransFilterBtn}
        setFilterValues={setFilterValues}
        downloadLoading={downloadLoading}
        pagination={pagination}
        setPagination={setPagination}
        firstLoad={firstLoad}
        setFirstLoad={setFirstLoad}
      />

      <TableTemplateCSS>
        <TableTemplate
          data={formData}
          columns={columns}
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
          columnPinning={columnPinning}
          columnVisibility={columnVisibility}
          setColumnVisibility={setColumnVisibility}
          showMetrics={showMetrics}
          manualPagination={true}
          pagination={pagination}
          setPagination={setPagination}
          totalCount={totalCount}
        />
      </TableTemplateCSS>
    </div>
  )
}

export default USSD_Trans_List
